import ajax from '@/libs/api.request'
export default {
  getZoneList:param=>{
    return ajax.post('edu/web/zone/getZoneList',param);
  },
  getZoneDetail:param=>{
    return ajax.post('edu/web/zone/getZoneDetail',param);
  },
  delZone:param=>{
    return ajax.post('edu/web/zone/delZone',param);
  },
  saveZone:param=>{
    return ajax.post('edu/web/zone/saveZone',param);
  },
  getAll:param=>{
    return ajax.get('edu/web/zone/getAll',param);
  },
}
